import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";
import { setItemInLocalStorage } from "../../../utils/localStorageHelper";

export const determineIfDrugTabShouldBeShown = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const authEntries = singleMedicalPaOrder?.auth_on_file?.auth_entries;
  if (authEntries && authEntries.length > 0) {
    const allJcodes = authEntries.map((entry) => entry.j_codes).flat();
    return allJcodes.length > 0;
  }
  return false;
};

export const determineIfBusniessOfficeTabShouldBeShown = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const reports = singleMedicalPaOrder?.auth_on_file?.reports;
  if (reports && reports.length > 0) {
    return reports.length > 0;
  }
  return false;
};

export const determineIfDocumentTabShouldBeShown = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const ifJCodeIsAvailable =
    determineIfDrugTabShouldBeShown(singleMedicalPaOrder);

  if (ifJCodeIsAvailable) {
    const allJCodes = singleMedicalPaOrder?.auth_on_file?.auth_entries
      ?.map((entry) => entry.j_codes)
      .filter((jCode) => jCode && jCode?.length > 0)
      .flat();
    const docs = allJCodes?.map((jCode) => jCode?.documents).flat();
    return docs && docs?.length > 0 && docs?.some((doc) => doc !== undefined);
  }
  return false;
};

export const determineFinalTabsListToBeShown = (
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const tabSwitchElements: { id: string; label: string }[] = [];
  const ifDrugTabShouldBeShown =
    determineIfDrugTabShouldBeShown(singleMedicalPaOrder);
  const ifBusniessOfficeTabShouldBeShown =
    determineIfBusniessOfficeTabShouldBeShown(singleMedicalPaOrder);
  const ifDocumentTabShouldBeShown =
    determineIfDocumentTabShouldBeShown(singleMedicalPaOrder);

  if (ifDrugTabShouldBeShown) {
    tabSwitchElements.push({ id: "drugs", label: "Drugs" });
  }
  if (ifBusniessOfficeTabShouldBeShown) {
    tabSwitchElements.push({ id: "businessOffice", label: "Business Office" });
  }
  if (ifDocumentTabShouldBeShown) {
    tabSwitchElements.push({ id: "documents", label: "Documents" });
  }
  tabSwitchElements.push({ id: "auditTrial", label: "Audit Trail" });
  setItemInLocalStorage("indexTab", tabSwitchElements[0].id);
  return tabSwitchElements;
};
